/**
 * LLM コストビューの表示整形（純関数。テストは format.test.ts）。
 */

/** USD 表記（小数 4 桁。null はコスト不明として "—"） */
export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `$${value.toFixed(4)}`;
}

/** タブの表示名（タブ名が引けなかった＝削除済みなどは tabId をそのまま出す） */
export function formatTab(tabId: string, tabName: string | null | undefined): string {
  return tabName || tabId;
}

/** トークン数（カンマ区切り。null は "—"） */
export function formatTokens(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return value.toLocaleString();
}

/** ミリ秒を「h時間m分s秒」「m分s秒」「s秒」に整形する（null は "—"） */
export function formatDurationMs(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) return '—';
  const totalSeconds = Math.round(value / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) return `${hours}時間${minutes}分${seconds}秒`;
  if (minutes > 0) return `${minutes}分${seconds}秒`;
  return `${seconds}秒`;
}

/** 成功率（%）。母数 0 は null */
export function successRate(succeeded: number, total: number): number | null {
  if (total <= 0) return null;
  return (succeeded / total) * 100;
}

export function formatPercent(value: number | null): string {
  if (value === null) return '—';
  return `${value.toFixed(1)}%`;
}

/** ISO 日時をローカル表記（YYYY-MM-DD HH:mm）にする。null は "—" */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d} ${hh}:${mm}`;
}

/** `now` から見た経過ミリ秒（不正な日時は null） */
export function elapsedMs(from: string | null | undefined, now: Date): number | null {
  if (!from) return null;
  const time = new Date(from).getTime();
  if (Number.isNaN(time)) return null;
  return Math.max(0, now.getTime() - time);
}

/** バイト数を人間可読に整形 */
export function formatBytes(bytes: number): string {
  if (bytes >= 1e12) return `${(bytes / 1e12).toFixed(2)} TB`;
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(2)} GB`;
  if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(2)} MB`;
  if (bytes >= 1e3) return `${(bytes / 1e3).toFixed(2)} KB`;
  return `${bytes} B`;
}

/** YYYY-MM-DD */
export function formatDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
